import produce from 'immer';

// TYPES
import { Types, CadastrarSigla } from './types';
import { ReducerActionRotaSP } from '../../../../../types';

export const INITIAL_STATE: CadastrarSigla = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): CadastrarSigla {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRAR_SIGLA_REQUEST: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CADASTRAR_SIGLA_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.CADASTRAR_SIGLA_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CADASTRAR_SIGLA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
	});
}
